import { ParcelMessagesDTO, ParcelStatusesDTO } from "entities/shared/parcelCard.types";
import { DateTimeModel, SearchCoordinateDTO, SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { ShipmentCardMetadataDTO } from "entities/shared/subscriptionModel";
import { ValueOf } from "shared/lib/typeCheck.lib";

export const TransportTypeDTO = {
  TRUCK: "TRUCK",
} as const;

export const TransportModeDTO = {
  SEA: "SEA",
  AIR: "AIR",
  RAIL: "RAIL",
  ROAD: "ROAD",
  NULL: "NULL",
} as const;

export type FromToDTO = {
  location?: string | null;
  name: string;
  state: string | null;
  country: string | null;
  country_code: string | null;
  locode: string | null;
  lat: number | null;
  lng: number | null;
  timezone: string | null;
};

export type DepartureArrivalDateTimeDTO = {
  estimated?: DateTimeModel | null;
  actual?: DateTimeModel | null;
};

export const EventCodeDTO = {
  BKD: "BKD",
  RCS: "RCS",
  DEP: "DEP",
  ARR: "ARR",
  NFD: "NFD",
  CCD: "CCD",
  DLV: "DLV",
} as const;

export type LocationDTO = {
  name: string | null;
  state: string | null;
  country: string | null;
  country_code: string | null;
  locode: string | null;
  lat: number | null;
  lng: number | null;
  timezone: string | null;
};

export type EventDTO = {
  order_id: number | null;
  event_code: ValueOf<typeof EventCodeDTO> | null;
  description: string;
  location: LocationDTO | null;
  datetime: DepartureArrivalDateTimeDTO;
  transport_mode: ValueOf<typeof TransportModeDTO>;
};

export type RouteDTO = {
  from: FromToDTO;
  to: FromToDTO;
  is_actual: boolean;
  path: SearchCoordinateDTO[];
};

export type ParcelResponseDTO = {
  status: boolean;
  status_code: ValueOf<typeof ParcelMessagesDTO>;
  metadata: {
    request_parameters: {
      number: SearchReferenceDTO;
      carrier_code?: string;
    };
    updated_at: DateTimeModel;
    parcel_company: {
      name: string;
      url: string;
      carrier_code: string;
    };
  } & ShipmentCardMetadataDTO;
  data: {
    status: ValueOf<typeof ParcelStatusesDTO> | null;
    from: FromToDTO | null;
    to: FromToDTO | null;
    departure_datetime: DepartureArrivalDateTimeDTO | null;
    arrival_datetime: DepartureArrivalDateTimeDTO | null;
    events: EventDTO[];
    route?: RouteDTO[];
  };
};
